var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isLoading && !_vm.hasError
        ? _c(
            "div",
            { staticClass: "el-section el-centered eu-align-items_center" },
            [
              _c("emd-pagarme-loader", {
                staticClass: "fade-in",
                attrs: { color: "secondary" },
              }),
            ],
            1
          )
        : _vm._e(),
      !_vm.isLoading && _vm.hasError
        ? _c("global-error", {
            attrs: { theme: _vm.theme, code: _vm.errorCode },
          })
        : _vm._e(),
      [_c("router-view")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }